<div class='poam-component' style='height: 100%' *ngIf="project">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div style="display: flex; flex-direction: row; justify-content: space-between; flex:1 1 auto">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">Project
        Name: {{project.name}}</h2>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px;">
        Generated: {{date | date : 'MM/dd/yyyy hh:mm aa'}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
    </div>
  </div>

  <p-table [value]="items"
           #poamTable
           [style]="{'font-size': '0.8em'}"
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="SharedResponsibilityReport"
           [columns]="cols">

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix flex flex-row justify-content-end">
        <button type="button"
                pButton
                class="risksponge-button"
                icon="pi pi-file-excel"
                iconPos="left"
                (click)="poamTable.exportCSV()">
        </button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" pResizableColumn
            [ngStyle]="{'width': col['width'] || 'auto'}" style="font-weight: bold; text-align: center;">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      <tr>
        <ng-container *ngFor="let col of cols">
          <th *ngIf="col.field != 'controlItem.level'">
            <input pInputText type="text" placeholder="⌕"
                   (input)="poamTable.filter($event.target['value'], col.field, 'contains')">
          </th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols" [ngSwitch]="col.field">
          <span>{{item[col.field]}}</span>
        </td>
      </tr>
    </ng-template>


  </p-table>
</div>
